"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const comparison_operator_value_1 = require("../../comparison-operator.value");
exports.osVersionCondition = {
    id: 'osVersion',
    category: 'technology',
    value: {
        osAndVersionValue: [
            {
                value: 'Windows',
                label: 'Windows',
                versions: ['anyVersion', '10', '8.1', '8', '7', 'Vista'],
            },
            {
                value: 'Mac OS X',
                label: 'Mac OS X',
                versions: ['anyVersion', '10.15', '10.14', '10.13', '10.12', '10.11', '10.10', '10.9', '10.8', '10.7', '10.6', '10.5'],
            },
            { value: 'Linux', versions: ['anyVersion', 'x86_64', 'i686'] },
            {
                value: 'Ubuntu',
                label: 'Ubuntu',
                versions: ['anyVersion', '19.10', '19.04', '18.10', '18.04', '17.10', '17.04', '16.10', '16.04', '15.10', '15.04', '14.10'],
            },
            {
                value: 'iOS',
                label: 'iOS',
                versions: [
                    'anyVersion',
                    '13.3',
                    '13.2',
                    '13.1',
                    '13.0',
                    '12.4',
                    '12.3',
                    '12.2',
                    '12.1',
                    '12.0',
                    '11.4',
                    '11.3',
                    '11.2',
                    '11.1',
                    '11.0',
                    '10.3',
                    '10.2',
                    '10.1',
                    '10.0',
                    '9.3',
                    '9.2',
                    '9.1',
                    '9.0',
                    '8.4',
                    '8.3',
                    '8.2',
                    '8.1',
                    '8.0',
                ],
            },
            {
                value: 'Android',
                label: 'Android',
                versions: [
                    'anyVersion',
                    '10',
                    '9',
                    '8.1',
                    '8.0',
                    '7.1',
                    '7.0',
                    '6.1',
                    '6.0',
                    '5.1',
                    '5.0',
                    '4.4',
                    '4.3',
                    '4.2',
                    '4.1',
                    '4.0',
                    '2.3',
                ],
            },
            {
                value: 'Windows Phone',
                label: 'Windows Phone',
                versions: ['anyVersion', '10', '8.1', '8.0'],
            },
        ],
        operatorValues: [
            { value: comparison_operator_value_1.ComparisonOperators.MATCH_REGEX, label: 'CONDITION_SELECT_IS' },
            { value: comparison_operator_value_1.ComparisonOperators.DOES_NOT_MATCH_REGEX, label: 'CONDITION_SELECT_IS_NOT' }
        ],
    },
};
//# sourceMappingURL=os-version-condition.value.js.map